import {InputValidator} from "../InputValidationHandler";
import {InternationalPhoneInputInterface} from "./InternationalPhoneInput";

export class InternationalPhoneValidator implements InputValidator {
    private readonly internationalPhoneInput: InternationalPhoneInputInterface;

    constructor(internationalPhoneInput: InternationalPhoneInputInterface) {
        this.internationalPhoneInput = internationalPhoneInput;
    }

    isValid(element: HTMLInputElement) {
        return this.internationalPhoneInput.isPhoneValid();
    }
}